import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { computeReportViews, dataAsOf } from '@tallyframe/core';
import { ReportGrid } from './internal/ReportGrid.js';
import { ReportHeader } from './internal/ReportHeader.js';
/**
 * Read-only dashboard.
 *
 * Exactly the same grid, the same cards and the same numbers as `ReportEditor`
 * — it shares the surface component with it — minus every editing affordance.
 */
export function ReportViewer(props) {
    const locale = props.locale ?? props.brand?.theme?.locale ?? 'en-US';
    const views = useMemo(() => computeReportViews(props.definition, props.data, locale), [props.definition, props.data, locale]);
    const header = (_jsx(ReportHeader, { title: props.definition.title, subtitle: props.definition.subtitle, preparedFor: props.definition.preparedFor, dataAsOf: dataAsOf(props.data.snapshot), brand: props.brand }));
    return (_jsx(ReportGrid, { definition: props.definition, views: views, interactive: false, className: props.className, brand: props.brand, header: header }));
}
//# sourceMappingURL=ReportViewer.js.map